import { Sparkles, ChevronDown } from "lucide-react";
import { motion } from "framer-motion";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { APP_VERSION, WHATS_NEW, WHATS_NEW_TITLE, WHATS_NEW_DATE } from "@/lib/site";

export const VersionBadge = () => (
  <Popover>
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} className="mb-8">
      <PopoverTrigger asChild>
        <button type="button" data-testid="hero-badge" className="group inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-left font-mono-x text-[11px] uppercase tracking-[0.2em] text-[#c4c8cf] transition-[border-color,background-color] duration-300 hover:border-[#ff6a3d]/50 hover:bg-[#ff6a3d]/10">
          <span className="pulse-dot h-2 w-2 shrink-0 rounded-full bg-[#ff6a3d]" />
          <span>Beta {APP_VERSION} · <span className="text-[#ff8a3d]">What's new</span> · Coming to Google Play & the App Store</span>
          <ChevronDown className="h-3.5 w-3.5 shrink-0 transition-transform duration-300 group-data-[state=open]:rotate-180" />
        </button>
      </PopoverTrigger>
    </motion.div>
    <PopoverContent align="start" sideOffset={10} data-testid="whats-new-panel" className="w-[min(24rem,calc(100vw-2.5rem))] rounded-2xl border border-white/10 bg-[#16181f]/95 p-5 text-[#f2f3f5] shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9)] backdrop-blur-xl">
      <p className="flex items-center gap-2 font-mono-x text-[11px] uppercase tracking-[0.2em] text-[#ff8a3d]"><Sparkles className="h-3.5 w-3.5" /> What's new in {APP_VERSION} · {WHATS_NEW_DATE}</p>
      <p data-testid="whats-new-title" className="mt-2 font-display text-2xl font-extrabold uppercase leading-none">{WHATS_NEW_TITLE}</p>
      <ul className="mt-4 space-y-3">
        {WHATS_NEW.map(([title, text], i) => (
          <motion.li key={title} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.05 + i * 0.06 }} data-testid={`whats-new-item-${i}`} className="flex gap-3">
            <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-grad" />
            <span><span className="block text-sm font-semibold">{title}</span><span className="text-sm leading-snug text-[#b3b8c1]">{text}</span></span>
          </motion.li>
        ))}
      </ul>
    </PopoverContent>
  </Popover>
);
